import request from '@/utils/request'

/**
 * 查询商品分类列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回商品分类列表
 */
export function queryProductCategory(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productCategory.queryProductCategory',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加商品分类
 * @param {Object} data 商品分类数据
 * @returns {Promise} 返回操作结果
 */
export function saveProductCategory(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productCategory.saveProductCategory',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新商品分类
 * @param {Object} data 商品分类数据
 * @returns {Promise} 返回操作结果
 */
export function updateProductCategory(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productCategory.updateProductCategory',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除商品分类
 * @param {Object} data 商品分类数据
 * @returns {Promise} 返回操作结果
 */
export function deleteProductCategory(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/productCategory.deleteProductCategory',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res.msg)
      }
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}